import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Arquive, Breadcrumb } from '../../services';

export type ArquiveState = {
  arquives: Partial<Arquive>[];
  breadcrumbs: Breadcrumb[];
  selectedArquive: Partial<Arquive> | null;
  setSelectedArquive: (account: Arquive) => void;
  setArquives: (arquives: Arquive[]) => void;
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
  searchArchives: string;
  setSearchArchives: (type: string) => void;
};

const useArquiveStore = create(
  persist<ArquiveState>(
    set =>
      ({
        arquives: [],
        selectedArquive: null,
        breadcrumbs: [],
        searchArchives: '',
        setSelectedArquive: (account: Arquive) =>
          set({
            selectedArquive: account,
          }),
        setArquives: (arquives: Arquive[]) =>
          set({
            arquives,
          }),
        setBreadcrumbs: (breadcrumbs: Breadcrumb[]) =>
          set({
            breadcrumbs,
          }),
        setSearchArchives: (searchArchives: string) =>
          set({
            searchArchives,
          }),
      } as ArquiveState),
    {
      name: '@tenGovUseArquiveStore',
    },
  ),
);

export default useArquiveStore;
